import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { CompaniesPickerComponent } from '@components/companies-picker/companies-picker.component';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { I18NextPipe } from 'angular-i18next';
import { AlertComponent, CardComponent, CardGroupComponent, LoaderComponent, MbsPopupType, RadioComponent } from 'mbs-ui-kit';
import { Company } from 'mbs-ui-shared@models';
import { StorageWizardCompanies } from 'mbs-ui-shared@models/StorageAccount';

@Component({
  selector: 'mbs-companies-step',
  templateUrl: './companies-step.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    AlertComponent,
    CardComponent,
    CardGroupComponent,
    CompaniesPickerComponent,
    I18NextPipe,
    LoaderComponent,
    NgbTooltipModule,
    RadioComponent,
    ReactiveFormsModule
  ]
})
export class CompaniesStepComponent {
  public readonly mbsPopupType = MbsPopupType;

  @Input() companiesData: StorageWizardCompanies;
  @Input() companiesLocked = false;
  @Input() loading = false;
  @Input() restrictControl: FormControl<boolean>;
  @Input() companiesControl: FormControl<Company[]>;
  @Input() selectedCompanyIds: string[] = [];
}
